import { Grid } from '@mui/material'
import { AppBox, AppTypography } from 'components'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import { AuthSliceSelector } from 'store/slices'

interface Props {}

export const UnAuthorized: FC<Props> = () => {
  const { CurrentUser } = useSelector(AuthSliceSelector)
  return (
    <AppBox height={'91vh'} alignContent={'center'}>
      <Grid container justifyContent={'center'}>
        <Grid item xs={4}>
          <AppBox backgroundColor="white" borderRadius={6} border={1} borderColor={'grey.200'} padding={2}>
            <AppBox borderBottom={1} borderColor={'grey.200'} paddingBottom={1}>
              <AppTypography fontSize={32} fontWeight={'bold'}>
                Unauthorized Access Denied
              </AppTypography>
            </AppBox>
            <AppTypography fontSize={16} fontWeight={400} color={'grey.500'} paddingTop={2}>
              You have attempted to access part of our site without authorization. This activity has been recorded and
              can result in your account being permanently banned if it continues.
            </AppTypography>
          </AppBox>
        </Grid>
        <Grid item xs={2}>
          <img src="/images/pax/Error.png" alt="old-cancelled-message" />
        </Grid>
      </Grid>
    </AppBox>
  )
}
